import { Share2, MessageSquare, Facebook, Twitter, Link2, Send } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export function ShareButton({ title, text, path, testId = "share-button", label = "Share" }) {
  const url = `${window.location.origin}${path}`;
  const msg = `${text} ${url}`;
  const enc = encodeURIComponent;
  const open = (href) => window.open(href, "_blank", "noopener,noreferrer");
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch (e) {
      toast(url);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={testId} className="flex items-center gap-1.5 rounded-full border border-zinc-700 px-3.5 py-2 text-sm font-semibold text-zinc-200 hover:border-[#fde68a] hover:text-[#fde68a]">
          <Share2 size={15} /> {label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        {navigator.share && (
          <DropdownMenuItem data-testid="share-native" onClick={() => navigator.share({ title, text, url }).catch(() => {})}>
            <Send size={14} className="mr-2" /> Share…
          </DropdownMenuItem>
        )}
        <DropdownMenuItem data-testid="share-sms" onClick={() => { window.location.href = `sms:?&body=${enc(msg)}`; }}>
          <MessageSquare size={14} className="mr-2" /> Text message
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="share-whatsapp" onClick={() => open(`https://wa.me/?text=${enc(msg)}`)}>
          <Send size={14} className="mr-2" /> WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="share-facebook" onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`)}>
          <Facebook size={14} className="mr-2" /> Facebook
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="share-x" onClick={() => open(`https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}`)}>
          <Twitter size={14} className="mr-2" /> X / Twitter
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="share-copy" onClick={copy}>
          <Link2 size={14} className="mr-2" /> Copy link
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
